import { Component, EventEmitter, Input, Output } from "@angular/core";

/**
 * "Upload Guidelines" panel.
 * Design reference: docs/AI/Review Guidence.png
 *
 * Opened from the "See upload guidelines" link on the Step 1 upload card.
 */
@Component({
    selector: "maia-guidelines-panel",
    templateUrl: "./maia-guidelines-panel.component.html",
    styleUrls: ["./maia-guidelines-panel.component.scss"],
})
export class MaiaGuidelinesPanelComponent {
    @Output() readonly closed = new EventEmitter<void>();

    /** "Download Template" — no template endpoint exists yet. */
    @Output() readonly templateRequested = new EventEmitter<void>();

    /** True while the parent is fetching the template — disables the button. */
    @Input() isDownloadingTemplate = false;

    /** Message shown under the button when the download failed. */
    @Input() templateError = "";

    readonly requirements = [
        "One location per row.",
        "One field per column.",
        "Column headers in the first row.",
        "A full address or latitude and longitude for every location.",
        "Name the worksheet that contains the locations you want to upload to MAPTYCS.",
    ];

    readonly supportedTypes = ["CSV", "XLSX", "XLS", "JSON"];

    readonly exclusions = [
        "Merged cells",
        "Totals or summary rows.",
        "Notes or comments within the data table.",
    ];
}
